import Environment from '../environment/environment.js';

export const CcrReaderMixin = {

  //@@viewOn:statics
  statics: {
    UU5_Common_ccrReaderMixin: {
      requiredMixins: ['UU5_Common_BaseMixin'],
      errors: {
        keyNotRegistered: 'Component with key %s is not registered.'
      }
    }
  },
  //@@viewOff:statics

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    // initialize
    this.registerMixin('UU5_Common_ccrReaderMixin');
    // state
    return null;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  hasUU5_Common_ccrReaderMixin: function () {
    return this.hasMixin('UU5_Common_ccrReaderMixin');
  },

  getUU5_Common_ccrReaderMixinProps: function () {
    return {};
  },

  getUU5_Common_ccrReaderMixinPropsToPass: function () {
    return this.getUU5_Common_ccrReaderMixinProps();
  },

  getCcrComponentByKey: function (key) {
    var component = this.getCcrByKeyRegister()[key];
    !component && this.showError('keyNotRegistered', key, {
      mixinName: 'UU5_Common_ccrReaderMixin'
    });
    return component;
  },

  isCcrRegisteredByKey: function (key) {
    return !!this.getCcrByKeyRegister()[key];
  },

  getCcrByKeyRegister: function () {
    return Environment.ccr.byKey;
  }
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers
};

export default CcrReaderMixin;



// WEBPACK FOOTER //
// ./common/ccr-reader-mixin.js